import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import MenuItem from '@material-ui/core/MenuItem';
import { useWindowWidth } from '@react-hook/window-size';

import { ALTERNATIVES, PLASTICS } from '../../Data';
import { Item as ItemType } from '../../Types';
import { Co2SavingText, Container, Content, RemoveItemButton, StyledTextField } from './styled';

interface Props {
    data: ItemType;
    updateItem: (itemId: string, key: keyof ItemType, value: string | number) => void;
    removeItem: (itemId: string) => void;
    count: number;
}

const Item = (props: Props) => {
    const { data, updateItem, removeItem, count } = props;

    const plastic = PLASTICS.find(p => p.name === data.plastic);
    const alternative = ALTERNATIVES.find(a => a.name === data.alternative);

    const co2Saving = (!plastic || !alternative) ? 0 : (plastic.value * data.amount - alternative.value * data.amount);

    const windowWidth = useWindowWidth();
    const { t } = useTranslation();

    const [internalAmount, setInternalAmount] = useState<any>('0');

    return (
        <Container variant='outlined'>
            <Content>
                <StyledTextField
                    value={data.plastic}
                    label={t('pages.co2_external_tool.item.plastic')}
                    variant='outlined'
                    onChange={(e) => updateItem(data.id, 'plastic', e.target.value)}
                    fullWidth={windowWidth <= 900}
                    select
                >
                    {PLASTICS.map(p => {
                        return (
                            <MenuItem value={p.name} >
                                {t('pages.co2_external_tool.plastics.' + p.name)}
                            </MenuItem>
                        );
                    })}
                </StyledTextField>

                <StyledTextField
                    value={data.alternative}
                    label={t('pages.co2_external_tool.item.alternative')}
                    variant='outlined'
                    onChange={(e) => updateItem(data.id, 'alternative', e.target.value)}
                    fullWidth={windowWidth <= 900}
                    select
                >
                    {ALTERNATIVES.map(a => {
                        return (
                            <MenuItem value={a.name} >
                                {t('pages.co2_external_tool.alternatives.' + a.name)}
                            </MenuItem>
                        );
                    })}
                </StyledTextField>

                <StyledTextField
                    value={internalAmount}
                    label={t('pages.co2_external_tool.item.quantity')}
                    variant='outlined'
                    onChange={(e) => {
                        setInternalAmount(e.target.value);
                        updateItem(data.id, 'amount',  Math.max(0, parseFloat(e.target.value.replaceAll(',', '.'))).toString().slice(0, 14));
                    }}
                    onBlur={() => {
                        setInternalAmount(Math.max(0, parseFloat(internalAmount.replaceAll(',', '.'))).toString().slice(0, 14));
                    }}
                    type='number'
                    fullWidth={windowWidth <= 900}
                    inputProps={{ min: 0, max: 1000000000 }} />
            </Content>

            {count > 1 && (
                <>
                    <Co2SavingText variant='body1'>
                        {t('pages.co2_external_tool.item.co2_saving', { co2Saving: isNaN(co2Saving) ? '-' : co2Saving.toFixed(2) })}
                    </Co2SavingText>

                    <RemoveItemButton variant='outlined' color='secondary' size='small' onClick={() => removeItem(data.id)}>
                        {t('pages.co2_external_tool.item.remove_item')}
                    </RemoveItemButton>
                </>
            )}
        </Container>
    );
};


export default Item;